<template>
  <div class="flex-between">
    <div class="flex-column editor-sub-header-title">
      <span v-if="info.company" class="desc bold-text">{{ info.company }}</span>
      <span v-else-if="info.name" class="desc bold-text">{{ info.name }}</span>
      <span v-else-if="info.university" class="desc bold-text">
        {{ info.university }}
        <div class="school-tags-container" v-if="info.university && info.show_tags && info.show_tags.length">
          <div class="school-tags-content">
            <div class="school-tag-item" v-for="itemD in info.show_tags">
              {{ itemD }}
            </div>
          </div>
        </div>
      </span>
      <div class="desc information-module">
        <span v-if="info.major">{{ info.major }}</span>
        <span v-if="info.degree">{{ info.degree }}</span>
        <span v-if="info.uni_school">{{ info.uni_school }}</span>
        <span v-if="info.title">{{ info.title }}</span>
        <span v-if="info.dept">{{ info.dept }}</span>
      </div>
    </div>
    <div class="flex-column-end editor-sub-header-title">
      <div class="desc" :class="{'order-after': cv.format_info.format_priority === 'city'}">
        <span v-if="info.start_at">{{ info.start_at | timeFilter(cv.format_info, cv.basic_info) }}</span>
        <span v-if="info.start_at && (info.end_at || info.present)"> - </span>
        <span v-if="info.end_at">{{ info.end_at | timeFilter(cv.format_info, cv.basic_info) }}</span>
        <span v-if="info.present">{{ info.present }}</span>
      </div>
      <div class="desc">{{ info.city }}</div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

let moment = require('moment')

export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  filters: {
    timeFilter: (val, format, basic) => {
      if (format.time_format === 'number') {
        return moment(val).format('YYYY.MM')
      } else {
        if (basic.lang === 'en') {
          return moment(val).format('MMM YYYY')
        } else {
          return moment(val).format('YYYY年MM月')
        }
      }
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapState('cv', ['cv'])
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.order-after {
  order: 2;
}

.bold-text {
  font-weight: 800;
  color: #000;
}

.information-module {
  span::before {
    content: '|';
    margin: 0 6px;
  }

  span:first-child::before {
    content: '';
    margin: 0;
  }
}

.school-tags-container {
  display: inline-block;
}

.school-tags-container .school-tags-content {
  display: flex;
  align-items: center;
  gap: 4px;
}

.school-tags-container .school-tags-content .school-tag-item {
  padding: 1px 4px;
  background: #E9F1FF;
  border-radius: 3px;
  font-size: 12px;
  font-family: zcoolwenyiti;
  color: #508CFF;
}
</style>
